# Ждут ответа команды (OPEN и VIEWER_REPLIED): то же, что значок меню.
query OpenSupportRequests($rowsPerPage: Int!) {
  supportRequests(filter: { needsReply: true }, rowsPerPage: $rowsPerPage) {
    count
    nodes {
      id
      type
      status
      message
      createdAt
      user {
        id
        email
      }
      platform {
        id
        title
      }
      organization {
        id
        title
      }
    }
  }
}
